export default class Role {

  //ROOD
  static readonly sysAdmin = 'SYS_ADMIN';
  static readonly bizAdmin = 'BIZ_ADMIN';

  //SEA
  static readonly admin = `ADMIN`;
  static readonly cdAdmin = `CD_ADMIN`;
  static readonly adminViewer = `ADMIN_VIEWER`;
  static readonly adminSelect = `ADMIN_SELECT`;
  static readonly developer = `DEVELOPER`;

  static readonly agent = `AGENT`;
  static readonly dealer = `DEALER`;
  static readonly dealerAgent = `DEALER_AGENT`;
  static readonly dealerManager = `DEALER_MANAGER`;

  static readonly concealedDamageAgent = `CD_AGENT`;
  static readonly concealedDamageStore = `CD_STORE`;
  static readonly ussi = `USSI`;
  static readonly ussiAdmin = `USSI_ADMIN`;
  static readonly be = `BE`;
  static readonly beAdmin = `BE_ADMIN`;
  static readonly ra = `RA`;
  static readonly raAdmin = `RA_ADMIN`;
  // SECA
  static readonly secaDealerStaff = 'DEALER_STAFF';
  static readonly secaDealerSuperVisor = 'DEALER_SUPERVISOR';
  static readonly secaAgent = 'DEALER_AGENT';
  static readonly secaAdmin = 'ADMIN';

  // SECA
  static readonly seaImDealerStaff = 'DEALER_STAFF';
  static readonly seaImDealerSuperVisor = 'DEALER_SUPERVISOR';
  static readonly seaImAgent = 'DEALER_AGENT';
  static readonly seaImAdmin = 'ADMIN';

  // B2B
  static readonly b2bCustomer = 'CUSTOMER';
  static readonly b2bCustomerAdmin = 'CUSTOMER_ADMIN';
  static readonly b2bPartner = 'PARTNER';
  static readonly b2bPartnerAdmin = 'PARTNER_ADMIN';
  static readonly b2bSvcVendor = 'SVC_VENDOR';
  static readonly b2bRsmAdmin = 'RSM_ADMIN';
};
